module.exports = __webpack_public_path__ + "img/pic-RonnieLi.6d4dd336.png";